import { createTheme } from '@mui/material';
 
export const DarkTheme = createTheme({
    palette: {
        primary: {
            main: '#00A351',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#fff',
        },
        background: {
            default: '#454545',
            paper: '#292929',
        },
        text: {
            primary: '#fff',
            secondary: '#fff'
        },
        divider: '#a3a3a3'
    },
    typography: {
        allVariants: {
            color: 'white'
        }
    },
    components: {
        MuiTextField: {
            styleOverrides: {
              root: {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'white',
                  },
                  '&:hover fieldset': {
                    borderColor: 'white',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'white',
                  },
                  '& input:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #292929 inset',
                    WebkitTextFillColor: 'white',
                  },
                },
                '& .MuiInput-underline:before': {
                  borderBottomColor: 'white',
                },
                '& .MuiInput-underline:hover:before': {
                  borderBottomColor: 'white',
                },
                '& .MuiInput-underline:after': {
                  borderBottomColor: 'white',
                },
              },
            },
        },
        MuiSelect: {
            styleOverrides: {
                icon: {
                    color: 'white', // Define a cor branca para o ícone do Select
                },
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'white',
                        },
                        '&:hover fieldset': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'white',
                        },
                        '&.MuiSelect-icon':{
                            color: 'white',
                        },
                    },
                    '& .MuiInput-underline:before': {
                        borderBottomColor: 'white',
                    },
                    '& .MuiInput-underline:hover:before': {
                        borderBottomColor: 'white',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: 'white',
                    },
                    '&. .MuiInput: disabled': {
                        color: 'black'
                    }
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
              root: {
                '& fieldset': {
                  borderColor: 'white',
                },
                '&:hover fieldset': {
                  borderColor: 'white',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'white',
                },
                borderRadius: '10px',
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 100px #292929 inset',
                  WebkitTextFillColor: 'white',
                },
              },
            },
          },
        MuiAutocomplete: {
            styleOverrides: {
                popupIndicator: {
                    color: 'white'
                },
                clearIndicator: {
                    color: 'white'
                }
            }
        },
        MuiAccordion: {
            defaultProps: {
                square: true,
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: '30px',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: 'white',
                },
            },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              borderColor: '#004D26BF',
              color: 'white',
              // backgroundColor: '#004D26',
              borderRadius: '25px',
              '&:disabled': {
                backgroundColor: '#aeaeae'
              }
            },
          }
        },
        MuiIcon: {
          styleOverrides: {
            root: {
              color: 'white',
            }
          }
        },
        MuiTab: {
          styleOverrides: {
            root: {
              '&:disabled': {
                color: 'white'
              }
            }
          }
        }
    },
});